import { OrgInvitationStatus } from 'pure-js/types/OrgInvitation'
import { OrgRole } from 'pure-js/types/OrganizationMembership'

export function orgRoleTranslationKey(
  role: OrgRole
): 'org.roles.ADMIN' | 'org.roles.FACILITATOR' | 'org.roles.LEADER' | 'org.roles.GAMER' {
  switch (role) {
    case OrgRole.ADMIN:
      return 'org.roles.ADMIN'
    case OrgRole.FACILITATOR:
      return 'org.roles.FACILITATOR'
    case OrgRole.LEADER:
      return 'org.roles.LEADER'
    case OrgRole.GAMER:
    default:
      return 'org.roles.GAMER'
  }
}

export function orgInviteStatusTranslationKey(
  status: OrgInvitationStatus
):
  | 'org.invites.status.PENDING'
  | 'org.invites.status.ACCEPTED'
  | 'org.invites.status.EXPIRED'
  | 'org.invites.status.REVOKED' {
  switch (status) {
    case OrgInvitationStatus.PENDING:
      return 'org.invites.status.PENDING'
    case OrgInvitationStatus.ACCEPTED:
      return 'org.invites.status.ACCEPTED'
    case OrgInvitationStatus.EXPIRED:
      return 'org.invites.status.EXPIRED'
    case OrgInvitationStatus.REVOKED:
    default:
      return 'org.invites.status.REVOKED'
  }
}
